<template>
  <div class="language-switcher">
    <el-dropdown @command="changeLanguage" trigger="click">
      <button class="language-btn">
        <i class="fas fa-globe"></i>
        <span>{{ currentLanguageName }}</span>
        <i class="fas fa-chevron-down"></i>
      </button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="zh">
            <span class="flag">🇨🇳</span>
            {{ t('language.zh') }}
          </el-dropdown-item>
          <el-dropdown-item command="en">
            <span class="flag">🇺🇸</span>
            {{ t('language.en') }}
          </el-dropdown-item>
          <el-dropdown-item command="ja">
            <span class="flag">🇯🇵</span>
            {{ t('language.ja') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const currentLanguageName = computed(() => {
  const languageMap = {
    zh: t('language.zh'),
    en: t('language.en'),
    ja: t('language.ja')
  };
  return languageMap[locale.value] || t('language.zh');
});

const changeLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('locale', lang);
};
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}

.language-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: #333;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.language-btn:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.language-btn i {
  font-size: 12px;
}

.flag {
  margin-right: 8px;
  font-size: 16px;
}

:deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: #f0f2f5;
}

:deep(.el-dropdown-menu) {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}
</style>
